import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "radio_active",
  "use": "radio_active-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"radio_active\"><g fill-rule=\"evenodd\"><path d=\"M7 12.833A5.833 5.833 0 117 1.167a5.833 5.833 0 010 11.666M7 0C3.14 0 0 3.14 0 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7\" /><path d=\"M7 2.333a4.667 4.667 0 100 9.334 4.667 4.667 0 000-9.334\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id